import { getHomeAppraisalPredictions } from 'utils/google-maps/api/homeAppraisalPlaces';
import { AutocompletePredictionPredictionCategory } from 'utils/google-maps/types';
import { processPredictions } from './utils';
import { SearchStrategyProps, SearchResult } from './SearchStrategy';
import { CountryCode } from 'types/countries';
import { BaseSearchStrategy } from './BaseSearchStrategy';
import SearchPrediction from 'data/search-predictions';

export class HomeAppraisalSearchStrategy extends BaseSearchStrategy {
  /**
   * Process search results specifically for home appraisal
   */
  protected async processSearchResults(goSearchPredictions: SearchPrediction[], props: SearchStrategyProps): Promise<SearchResult> {
    const { queryString, siteLocation } = props;

    // Get predictions from Google Maps specifically for home appraisal
    const googleSearchPredictions = await getHomeAppraisalPredictions(queryString, siteLocation as CountryCode);

    // Handle the filtering based on prediction count
    if (googleSearchPredictions.length > 9) {
      // If more than 9 Google results, use only the top 10 Google results
      const limitedGooglePredictions = googleSearchPredictions.slice(0, 10);
      
      return {
        searchPredictions: limitedGooglePredictions,
        searchAgentPredictions: [],
      };
    } else {
      // If less than 10 Google results, fill the remaining slots with go-search results
      const remainingSpaceForPredictions = 10 - googleSearchPredictions.length;
      
      // Remove cities from searchPredictions we received from go-search
      const filteredGoSearchPredictions = goSearchPredictions
        .filter(p => p.label !== AutocompletePredictionPredictionCategory.CITY)
        .slice(0, remainingSpaceForPredictions);
      
      // Process and combine predictions with home appraisal flag set to true
      const finalPredictions = processPredictions(
        filteredGoSearchPredictions, 
        googleSearchPredictions, 
        true
      );

      return {
        searchPredictions: finalPredictions,
        searchAgentPredictions: [],
      };
    }
  }
} 